export const ADDPRODUCTTOSTOCK = "productItems/addItemProduct";
export const ADDPRODUCTSTOSTOCK = "productItems/addItemsProducts";
export const HANDLESTOCKITEMQUENTITY = "productItems/HandleStockItemQuantity";
